import { render, staticRenderFns } from "./Sales-board.vue?vue&type=template&id=3c090d26&scoped=true"
import script from "./Sales-board.vue?vue&type=script&lang=js"
export * from "./Sales-board.vue?vue&type=script&lang=js"
import style0 from "./Sales-board.vue?vue&type=style&index=0&id=3c090d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c090d26",
  null
  
)

export default component.exports